var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon-button",on:{"click":function($event){return _vm.$emit('click', $event)}}},[(_vm.$slots.default)?_c('span',[_vm._t("default")],2):_vm._e(),_vm._v(" "),(!_vm.fa)?_c('i',{class:[_vm.icon, _vm.colorTheme],style:(_vm.fontSize)}):_c('fa',{class:[_vm.colorTheme],style:(_vm.fontSize),attrs:{"icon":_vm.icon}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4da72572","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/IconButton.vue
// module id = null
// module chunks = 